var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82 72"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.523 11.877 80.19 31.613A6.242 6.242 0 0 1 82 36c0 1.64-.657 3.23-1.81 4.388L60.523 60.123a5.407 5.407 0 0 1-3.844 1.591c-2.995 0-5.429-2.443-5.429-5.448v-9.98h-20.5a5.128 5.128 0 0 1-5.125-5.143V30.857a5.128 5.128 0 0 1 5.125-5.143h20.5v-9.98c0-3.005 2.434-5.448 5.43-5.448 1.44 0 2.818.578 3.843 1.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.625 10.286h-10.25a5.128 5.128 0 0 0-5.125 5.143V56.57a5.128 5.128 0 0 0 5.125 5.143h10.25a5.128 5.128 0 0 1 5.125 5.143A5.128 5.128 0 0 1 25.625 72h-10.25C6.887 72 0 65.09 0 56.571V15.43C0 6.91 6.887 0 15.375 0h10.25a5.128 5.128 0 0 1 5.125 5.143 5.128 5.128 0 0 1-5.125 5.143",
    opacity: 0.4
  }))));
};
export default SvgLogout;